<script setup>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {useRouter} from 'vue-router'
import {ref, onMounted, nextTick} from "vue";
import axios from "axios"

const router = useRouter()

const stores = ref([
  // { id: 'Kabul Super Market', model: 'Afghanistan', total_tokens: 'AFN', completion_tokens: 0.05, prompt_tokens: 0.02, message: new Date() },
])


const responseText = ref([])

function goToPageAddGpt() {
  router.push('/add-chatgpt')
}

const callApiChatGpt = async (prompt) => {
  const API_KEY = "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"


  try {
    const res = await axios.get(
        "https://api.openai.com/v1/chat/completions",
        {
          headers: {
            "Authorization": `Bearer ${API_KEY}`,
            "Content-Type": "application/json"
          },
          timeout: 300000
        }
    )
    stores.value = res.data.data.map(item => ({
      id: item.id,
      model: item.model,
      total_tokens: item.usage.total_tokens,
      completion_tokens: item.usage.completion_tokens,
      prompt_tokens: item.usage.prompt_tokens,
      message: item.choices?.[0]?.message?.content || ''
    }))
    await nextTick()
    window.dispatchEvent(new Event('resize'))

    responseText.value = res.data?.content || "❌ پاسخی از سرور دریافت نشد"
  } catch (err) {
    console.error("API Error:", err)
    responseText.value = "⚠️ خطا در ارتباط با سرور"
  } finally {
  }
}

const goToGptDetails = (event) => {

  const row = event.data;

  router.push({
    name: 'gpt-details',
    query: {
      id: row.id,
      message: row.message
    }
  })
}

onMounted(() => {
  callApiChatGpt()
})

</script>

<template>
  <div class="h-full flex flex-col gap-2">
    <button type="button"
            class="border border-slate-700 text-white !text-xs 2xl:!text-sm px-5 h-[32px] 2xl:h-[40px] rounded-md w-max hover:bg-slate-800 disabled:opacity-50 flex flex-row gap-2 items-center"
            @click="goToPageAddGpt"
    >
      New Request
    </button>
    <div class="flex flex-col gap-4 w-full h-full">
      <DataTable
          :nullSortOrder="-1"
          :value="stores"
          scrollable
          scrollHeight="flex"
          :virtualScrollerOptions="{ itemSize: 30 }"
          resizableColumns
          removableSort
          stripedRows
          class="text-xs w-full"
          size="small"
          tableStyle="width: 100%; table-layout: fixed;"
          row-hover
          @row-click="goToGptDetails"
          :rowClass="() => 'hover:!bg-[#2c4967] even:!bg-[#1A2941] odd:!bg-[#121E31] !text-slate-300 cursor-pointer'"
      >
        <Column field="id" header="id" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap !py-0"
                style="width: 20%; min-width: 100px; height: 30px">
        </Column>
        <Column field="model" header="model" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap"
                style="width: 8%; min-width: 100px; height: 30px"></Column>
        <Column field="total_tokens" header="total_tokens" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap"
                style="width: 8%; min-width: 100px; height: 30px"></Column>
        <Column field="completion_tokens" header="completion_tokens" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap"
                style="width: 8%; min-width: 100px; height: 30px"></Column>
        <Column field="prompt_tokens" header="prompt_tokens" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap"
                style="width: 8%; min-width: 100px; height: 30px"></Column>
        <Column field="message" header="message" dataType="numeric" :sortable="true"
                class="overflow-hidden text-ellipsis whitespace-nowrap"
                style="height: 30px"></Column>
        <template #empty>
          <h1 class="py-2 text-center text-lg">No Data</h1>
        </template>
      </DataTable>
    </div>

  </div>

</template>

<style scoped lang="scss">
.card {
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
}

:deep(.p-datatable) {
  margin: 0 !important;
  padding: 0 !important;
  scrollbar-width: thin;
  scrollbar-color: #4b5563 #1f2937;
}

:deep(.p-datatable-wrapper) {
  margin-top: 0 !important;
}

:deep(.p-datatable-table) {
  /*height: 100% !important;*/
  width: 100% !important;
  table-layout: fixed;
  border-collapse: collapse;
}

:deep(.p-datatable-thead) {
  position: sticky;
  top: 0;
  z-index: 20;
  background-color: #1a2941;
}

:deep(.p-datatable-thead th) {
  font-size: 0.75rem;
  white-space: nowrap;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  text-transform: capitalize;
  text-align: left;
  background-color: #1a2941 !important;
  border-top: 0;
}

:deep(.p-datatable-thead th.p-datatable-column-sorted) {
  background-color: #1E444F !important;
}

:deep(.p-datatable-column-sorted) {
  background-color: #1e444f !important;
}

:deep(.p-datatable-tbody > tr > td) {
  font-size: 0.75rem;
  text-align: left;
  padding: 0.3rem;
  text-transform: none;
}

:deep(.p-datatable::-webkit-scrollbar) {
  width: 8px;
}

:deep(.p-datatable::-webkit-scrollbar-track) {
  background: #1f2937;
}

:deep(.p-datatable::-webkit-scrollbar-thumb) {
  background: #4b5563;
  border-radius: 4px;
}
</style>